module.exports = __webpack_public_path__ + "static/media/slide-mobile-2.44ff5e22.png";